import * as yup from 'yup'

import { i18n } from '@/common/i18n'

export const helpFormValidationSchema = yup.object().shape({
  institutionName: yup.string().required(i18n().common.validators.required),
  name: yup.string().required(i18n().common.validators.required),
  email: yup
    .string()
    .email(i18n().common.validators.emailInvalid)
    .required(i18n().common.validators.required),
  obs: yup.string().required(i18n().common.validators.required)
})
